import { render, staticRenderFns } from "./userLayout.vue?vue&type=template&id=2c485622&scoped=true&"
import script from "./userLayout.vue?vue&type=script&lang=js&"
export * from "./userLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c485622",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheHeader: require('/Users/yghee/IdeaProjects/kcc_kccam/frontend/components/kccam/user/layout/TheHeader.vue').default,TheFooter: require('/Users/yghee/IdeaProjects/kcc_kccam/frontend/components/kccam/user/layout/TheFooter.vue').default})
